module.exports = __webpack_public_path__ + "img/register.e4c94727.svg";